<template>
	<div style="width: 1200px;margin: 70px auto;">
		<bar></bar>
		<div class="vehicle-box">
			<div class="vehicle-span">
				<span>活动限额：{{ activityLimit }}&nbsp;,&nbsp;活动剩余：{{ surplusLimit }}</span>
			</div>
		</div>
		<div class="zt-z">
			<span @click="toActivity">{{ activityName }}</span>
		</div>
		<div style="width: 1200px;height: 30px; margin-top: 20px;;border-bottom: 1px solid #000000;">
			<span style="font-size: 14px;float: left">首页/购物车</span>
		</div>

		<div class="content-box">
			<div style="width: 953px;">
				<el-table @selection-change="handleSelectionChange" ref="productListCheck" :header-cell-style="{background:'#e5e5e5',color:'#2c3e50'}" :data="list" fit highlight-current-row style="width: 100%">
					<el-table-column :selectable="selectable" type="selection" width="50">
					</el-table-column>
					<el-table-column align="center" label='图片' min-width="100">
						<template slot-scope="scope">
							<img style="width:40px;height:40px;" :src="$store.getters.imageUrl + '/' + scope.row.productImgPath" alt="" />
						</template>
					</el-table-column>
					<el-table-column align="center" label='商品名称' min-width="150">
						<template slot-scope="scope">
							{{scope.row.productName}}
						</template>
					</el-table-column>
					<el-table-column align="center" label='SKU code' min-width="120">
						<template slot-scope="scope">
							{{scope.row.skuCode}}
						</template>
					</el-table-column>
					<el-table-column align="center" label='福豆' min-width="100">
						<template slot-scope="scope">
							{{scope.row.unitPrice}}
						</template>
					</el-table-column>
					<el-table-column align="center" label='数量' min-width="150">
						<template slot-scope="scope">
							<el-input-number size="mini" :min="1" :max="scope.row.limitCount" v-model="scope.row.buyCount"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column min-width="120">
						<template slot-scope="scope">
							{{(scope.row.surplusCount >= scope.row.buyCount) ? (scope.row.buyCount > scope.row.canBuyCount?'超出限购量':'') : '库存不足'}}
						</template>
					</el-table-column>
					<el-table-column align="center" label='操作' min-width="120">
						<template slot-scope="scope">
							<img @click="modifyCarInfo(scope.row)" src="../assets/img/dui1.png" alt="" style="width: 15px;height: 15px;margin-right:15px;cursor: pointer;" />
							<img @click="delCarInfo(scope.row)" src="../assets/img/cha.png" alt="" style="width: 13px;height: 13px;cursor: pointer;" />
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div style="width: 247px;height: 246px;border: 2px solid grey;margin-top: 0px;">
				<div style="margin-top:18px;">
					<span>订单结算</span>
				</div>
				<div style="text-align: left;margin-left: 10px;"></div>
				<br />
				<i></i>
				<br />
				<p class="vehicle-head-p-p">总福豆</p>
				<div class="vehicle-p-box">
					<p class="vehicle-box-p">￥{{total}}</p>
				</div>
				<br />
				<div>
					<el-button style="margin-left: 3px;width: 214px;" @click="clearCarInfo" size="mini" id="vehicle-buttont">清空购物车</el-button>
					<el-button style="margin-left: 3px;" @click="toResult" size="mini" id="vehicle-button">订单结算</el-button>
				</div>
			</div>

		</div>
		<div style="height:160px;margin-top: 50px;">
			<el-button @click="toOrder" type="primary">返回活动</el-button>
		</div>
	</div>
</template>

<script>
import bar from '@/components/bar.vue'
import {
	carInfo,
	modifyCar,
	delCar,
	clearCar,
	orderCheck
} from '../api/service'

export default {
	data() {
		return {
			activityId: '',
			activityName: '',
			activityLimit: '',
			surplusLimit: '',
			total: '',
			list: []
		}
	},
	methods: {
		toOrder() {
			const para = {
				activityId: this.activityId,
				activityName: this.activityName,
				activityLimit: this.activityLimit.toString(),
				surplusLimit: this.surplusLimit.toString()
			}
			this.$router.push({ path: 'Activitylist', query: para })
		},
		handleSelectionChange(val) {
			this.totalAll()
		},
		selectable(row, index) {
			if (row.surplusCount >= row.buyCount) {
				if (row.buyCount > row.canBuyCount) {
					return false
				} else {
					return true
				}
			} else {
				return false
			}
		},
		fetchData() {
			const params = {
				page_index: '1',
				page_size: '1000',
				staffId: this.$store.getters.id,
				activityId: this.activityId
			}
			carInfo(params)
				.then(response => {
					if (response.data.success === true) {
						this.list = response.data.data.list
					}
					this.$nextTick(() => {
						this.$refs.productListCheck.toggleAllSelection()
					})
				})
				.catch(() => {
					this.list = null
				})
		},
		modifyCarInfo(item) {
			const params = {
				id: item.id,
				buyCount: item.buyCount
			}
			modifyCar(params)
				.then(response => {
					if (response.data.success === true) {
						this.$alert('修改成功', '提示', {
							confirmButtonText: '确定'
						})
						this.fetchData()
					} else {
						this.$alert('修改失败', '提示', {
							confirmButtonText: '确定'
						})
					}
				})
				.catch(() => {
					this.$alert('修改失败', '提示', {
						confirmButtonText: '确定'
					})
				})
		},
		delCarInfo(item) {
			this.$confirm('确定要删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					const params = {
						id: item.id
					}
					delCar(params)
						.then(response => {
							if (response.data.success === true) {
								this.$alert('删除成功', '提示', {
									confirmButtonText: '确定'
								})
								this.fetchData()
							} else {
								this.$alert('删除失败', '提示', {
									confirmButtonText: '确定'
								})
							}
						})
						.catch(() => {
							this.$alert('删除失败', '提示', {
								confirmButtonText: '确定'
							})
						})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		clearCarInfo(item) {
			this.$confirm('确定要清空购物车吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					const params = {
						activityId: this.activityId,
						staffId: this.$store.getters.id
					}
					clearCar(params)
						.then(response => {
							if (response.data.success === true) {
								this.$alert('操作成功', '提示', {
									confirmButtonText: '确定'
								})
								this.fetchData()
							} else {
								this.$alert('操作失败', '提示', {
									confirmButtonText: '确定'
								})
							}
						})
						.catch(() => {
							this.$alert('操作失败', '提示', {
								confirmButtonText: '确定'
							})
						})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					})
				})
		},
		toActivity() {
			const para = {
				activityId: this.activityId,
				activityName: this.activityName,
				activityLimit: this.activityLimit,
				surplusLimit: this.surplusLimit
			}
			this.$router.push({ path: 'Activitylist', query: para })
		},
		totalAll() {
			let count = 0
			for (
				let index = 0;
				index < this.$refs.productListCheck.selection.length;
				index++
			) {
				let temp =
					this.$refs.productListCheck.selection[index].unitPrice *
					this.$refs.productListCheck.selection[index].buyCount
				count = count + temp
			}
			this.total = count.toFixed(2)
		},
		toResult() {
			const idList = []
			for (
				let index = 0;
				index < this.$refs.productListCheck.selection.length;
				index++
			) {
				idList.push({
					id: this.$refs.productListCheck.selection[index].id
				})
			}
			if (idList.length === 0) {
				this.$alert('未选择商品', '提示', {
					confirmButtonText: '确定'
				})
				return
			}
			const para = {
				staffId: this.$store.getters.id,
				activityId: this.activityId,
				cartList: idList
			}
			orderCheck(para)
				.then(response => {
					if (response.data.success === true) {
						this.$router.push({ path: 'confirm', query: para })
					} else {
						this.$alert(response.data.message, '提示', {
							confirmButtonText: '确定'
						})
					}
				})
				.catch(() => {
					this.$alert('结算失败', '提示', {
						confirmButtonText: '确定'
					})
				})
		}
	},
	created() {
		this.activityId = this.$route.query.activityId
		this.activityName = this.$route.query.activityName
		this.activityLimit = this.$route.query.activityLimit
		this.surplusLimit = this.$route.query.surplusLimit
		this.fetchData()
	},
	components: {
		bar
	}
}
</script>

<style scoped="">
.content-box {
	display: flex;
}
a {
	text-decoration: none;
}
.clearfix:after {
	content: '';
	display: block;
	clear: both;
}
.list-bar-ui {
	text-align: left;
}
.list-bar-ui li {
	list-style: none;
	color: white;
	font-weight: 200;
	margin-left: 20px;
	cursor: pointer;
	display: inline-block;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	float: right;
	width: 209px;
	margin-top: 8px;
	padding-right: 300px;
}

.car-bar-box {
	cursor: pointer;
	width: 30px;
	height: 30px;
	background-image: url(../assets/img/cheo.png);
	background-size: 100%;
	background-repeat: no-repeat;
	position: absolute;
	top: 3px;
	right: 90px;
}
.zt-z {
	width: 120px;
	height: 42px;
	background-color: #be0f34;
}
.zt-z span {
	line-height: 42px;
	text-align: center;
	color: white;
	font-family: '黑体' !important;
}
.middle-table {
	width: 772px;
	margin: 0 auto;
}
.el-table td {
	text-align: center;
}
.vehicle-box {
	padding: 0px 15px;
	height: 42px;
	float: right;
	background-color: #be0f34;
	color: white;
}
.vehicle-span {
	line-height: 42px;
	text-align: center;
	color: white;
	font-family: '黑体' !important;
}
.vehicle-head {
	width: 741px;
	height: 40px;
	background-color: #e5e5e5;
}
.vehicle-head-font {
	float: left;
	font-size: 12px;
	line-height: 40px;
	margin-left: 10px;
}
.vehicle-head-font li {
	display: inline-block;
	padding-left: 79px;
	font-size: 13px;
}
.vehicle-head-fontt {
	float: right;
	font-size: 12px;
	line-height: 40px;
	margin-left: 10px;
}
.vehicle-head-fontt li {
	display: inline-block;
	padding-right: 73px;
	font-size: 13px;
}
.vehicle-p-box {
	text-align: left;
	margin-left: 30px;
	float: right;
}
.vehicle-p-box p {
	font-size: 14px;
	color: #000000;
	padding-right: 20px;
	display: inline-block;
}
.vehicle-box-p {
	font-size: 14px;
	color: #000000;
	padding-right: 20px;
	display: inline-block;
	padding-top: 18px;
}
.vehicle-head-p {
	font-size: 16px;
	color: #000000;
	display: inline-block;
	float: left;
	padding-left: 20px;
	padding-bottom: 20px;
}
.vehicle-head-p-p {
	font-size: 18px;
	color: #000000;
	display: inline-block;
	float: left;
	padding-left: 20px;
	padding-top: 14px;
}
i {
	width: 225px;
	height: 2px;
	border-bottom: 1px solid #e5e5e5;
	float: right;
	margin: 6px 9px 0 0;
}
.vehicle-middle-box {
	width: 741px;
	border-bottom: 1px solid #e5e5e5;
	height: 134px;
	position: relative;
}
.vehicle-middle-box img {
	width: 80px;
	height: 80px;
	position: absolute;
	top: -23px;
	left: 54px;
}
.vehicle-tu {
	width: 200px;
	font-size: 13px;
	margin-left: 0;
}
.vehicle-zi {
	width: 200px;
	font-size: 13px;
	margin-left: 182px;
}
.vehicle-number {
	width: 200px;
	font-size: 13px;
	margin-left: 98px;
}
.vehicle-money {
	width: 200px;
	font-size: 13px;
	margin-left: 71px;
}
.vehicle-numbert {
	position: absolute;
	top: 0;
	left: 510px;
	text-align: left;
}
.vehicle-operation {
	position: absolute;
	top: 28px;
	left: 585px;
	width: 200px;
	font-size: 13px;
	cursor: pointer;
}
.vehicle-operation-fork {
	position: absolute;
	top: 28px;
	left: 621px;
	width: 200px;
	font-size: 13px;
	cursor: pointer;
}
.el-input-number--mini {
	width: 88px !important;
}
</style>
